import { FeatureFlagMap, FeatureFlagsEnum } from '@/store/slices/feature-flags/types';
import { Get, Put, Delete } from './helpers';

export const GetFeatureFlags = async () => {
  return Get<FeatureFlagMap>({ path: '/v3/feature-flags', publicPath: true, useCache: true, cacheTtl: 60 });
};

export function OptInBetaFeature(feature: FeatureFlagsEnum): Promise<{ token: string }> {
  return Put({
    path: '/v4/admin/access-token/profile/beta-feature',
    body: { feature },
  });
}

export function OptOutBetaFeature(feature: FeatureFlagsEnum): Promise<{ token: string }> {
  return Delete({
    path: '/v4/admin/access-token/profile/beta-feature',
    body: { feature },
  });
}
